export default __webpack_public_path__ + "static/media/PlannedGiving.8ea821b6.png";